import Debug from 'debug';

const Debugger = function(namespace) {
    const debug = Debug(namespace);

    debug.log = function() {
        this.loggerArgs = arguments;
    };
    const logger = function(level) {
        if (debug.enabled) {
            try {

                const namespaceLevel = namespace + ':' + level;
                if (!console.hasOwnProperty(namespaceLevel)) {
                    Object.defineProperty(console, namespaceLevel, {
                        get: function() {
                            debug(level);
                            return debug.loggerArgs;
                        }
                    });
                }

                let logLevel = console.log;
                switch (level) {
                    case 'error':
                    case 'fatal':
                        logLevel = console.error;
                        break;
                    case 'warn':
                        logLevel = console.warn;
                        break;
                    case 'info':
                        logLevel = console.info;
                        break;
                    case 'debug':
                        logLevel = console.debug;
                        break;
                    case 'trace':
                        logLevel = console.trace;
                        break;
                    default:
                        logLevel = console.log;
                }

                return logLevel.bind(console, ...console[namespace + ':' + level]);
            }
            catch (e) {
                return console.error({ e });
            }
        }
        else {
            return function() {};
        }
    };
    return {
        fatal: logger('fatal'),
        error: logger('error'),
        warn: logger('warn'),
        log: logger('log'),
        info: logger('info'),
        debug: logger('debug'),
        trace: logger('trace')
    };
};
export default Debugger;